<template>
  <section class="px-4 py-12 md:py-20 flex flex-col items-center">
    <div class="w-full max-w-3xl flex flex-col items-center text-center gap-6">
      <h1>{{ t('landing.hero.title') }}</h1>

      <p class="text-lg md:text-xl text-neutral-200 max-w-2xl">
        {{ t('landing.hero.subline') }}
      </p>

      <div class="flex flex-col md:flex-row items-center gap-4 mt-2">
        <VaButton size="large" :to="{ name: 'start' }">
          {{ t('landing.hero.submit') }}
        </VaButton>
        <VaButton
          size="large"
          preset="secondary"
          color="primary"
          border-color="primary"
          href="#so-funktionierts"
        >
          {{ t('landing.hero.how') }}
        </VaButton>
      </div>

      <p class="text-sm text-neutral-300">{{ t('landing.hero.trust') }}</p>
    </div>

    <!-- One hour of the programme: the two spots are the only thing that is
         not music, which is the whole offer in one picture. -->
    <div class="w-full max-w-3xl mt-10" aria-hidden="true">
      <div class="flex flex-row justify-between text-xs text-neutral-400 mb-2">
        <span>{{ t('landing.hero.hourStart') }}</span>
        <span>{{ t('landing.hero.hourEnd') }}</span>
      </div>
      <div class="relative h-12 rounded-2xl bg-neutral-700 overflow-hidden">
        <div class="absolute inset-0 flex items-center justify-center text-sm text-neutral-300">
          {{ t('landing.hero.music') }}
        </div>
        <div
          v-for="position in SPOT_POSITIONS"
          :key="position"
          class="absolute top-0 bottom-0 w-2 bg-primary"
          :style="{ left: position }"
        />
      </div>
      <div class="relative h-6 mt-2 text-xs text-primary">
        <span
          v-for="position in SPOT_POSITIONS"
          :key="position"
          class="absolute -translate-x-1/2 whitespace-nowrap"
          :style="{ left: position }"
        >
          {{ t('landing.hero.spot') }}
        </span>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { VaButton } from 'vuestic-ui'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const SPOT_POSITIONS = ['25%', '75%']
</script>
